module.exports = __webpack_public_path__ + "r-v3/img/hand.d454a007.svg";